import { topshotsAPI } from '../../app/api';
// import { Image } from '../images/images.types';
import {
  IAlbum,
  IImage,
  PagedRequest,
  PagedResponse,
} from '@topshots/core-models';

const albumsApi = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    getAlbum: build.query<IAlbum, string>({
      query: (id) => ({
        url: `albums/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, page) => [
        { type: 'Albums' as const, id: result?._id.toString() },
      ],
    }),
    getAlbumChildren: build.query<
      PagedResponse<IAlbum[]>,
      PagedRequest & { id: string }
    >({
      query: (request) => ({
        url: `albums/${request.id}/albums`,
        method: 'GET',
        params: request,
      }),
      providesTags: (result, error, page) =>
        result
          ? [
              ...result.data.map(({ _id }) => ({
                type: 'Albums' as const,
                id: _id.toString(),
              })),
              { type: 'Albums', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Albums', id: 'PARTIAL-LIST' }],
    }),
    getAlbumRawImageUploadUrl: build.mutation<
      { url: string },
      {
        filename: string;
        albumId: string;
      }
    >({
      query: (req) => ({
        url: `albums/${req.albumId}/images/raw-upload-url`,
        method: 'POST',
        body: { filename: req.filename },
      }),
    }),
    // uploadAlbumImage: build.mutation<
    //   Image,
    //   {
    //     id: string;
    //     payload: {
    //       fileName: string;
    //       chunk: string;
    //       fileSize: number;
    //       chunkSize: number;
    //       chunkIndex: number;
    //     };
    //   }
    // >({
    //   query: (request) => ({
    //     url: `albums/${request.id}/images`,
    //     method: 'POST',
    //     body: request.payload,
    //   }),
    //   invalidatesTags: (result, error, product) => [],
    // }),
    getAlbumImages: build.query<
      PagedResponse<IImage[]>,
      PagedRequest & { id: string }
    >({
      query: (request) => ({
        url: `albums/${request.id}/images`,
        method: 'GET',
        params: request,
      }),
      providesTags: (result, error, page) =>
        result
          ? [
              ...result.data.map(({ _id }) => ({
                type: 'Images' as const,
                id: _id.toString(),
              })),
              { type: 'Images', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Images', id: 'PARTIAL-LIST' }],
    }),
    createAlbum: build.mutation<IAlbum, Partial<IAlbum>>({
      query: (request) => ({
        url: `albums`,
        method: 'POST',
        body: request,
      }),
      invalidatesTags: (result, error, product) => [
        { type: 'Albums', id: 'PARTIAL-LIST' },
        { type: 'Albums', id: result?._id.toString() },
      ],
    }),
    updateAlbum: build.mutation<IAlbum, { id: string; data: Partial<IAlbum> }>({
      query: (request) => ({
        url: `albums/${request.id}`,
        method: 'PUT',
        body: request.data,
      }),
      invalidatesTags: (result, error, product) => [
        { type: 'Albums', id: 'PARTIAL-LIST' },
        { type: 'Albums', id: result?._id.toString() },
      ],
    }),
    setAlbumCover: build.mutation<IImage, { id: string; image: File }>({
      query: (request) => {
        const data = new FormData();
        data.append('file', request.image);
        return {
          url: `albums/${request.id}/cover`,
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: (result, error, product) => [{ type: 'AlbumCover' }],
    }),
    getAlbumCover: build.query<IImage, string>({
      query: (id) => ({
        url: `albums/${id}/cover`,
        method: 'GET',
      }),
      providesTags: (result, error, page) => [
        { type: 'AlbumCover' as const, id: result?.album_id },
      ],
    }),
    deleteAlbumCover: build.mutation<void, string>({
      query: (id) => ({
        url: `albums/${id}/cover`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, product) => [{ type: 'AlbumCover' }],
    }),
  }),
});

export const {
  useGetAlbumCoverQuery,
  useSetAlbumCoverMutation,
  useDeleteAlbumCoverMutation,
  useGetAlbumQuery,
  useCreateAlbumMutation,
  useGetAlbumChildrenQuery,
  useUpdateAlbumMutation,
  useGetAlbumImagesQuery,
  useGetAlbumRawImageUploadUrlMutation,
  util,
} = albumsApi;
